var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_10",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 101
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 88C18.5417 88 16.5799 87.184 14.9479 85.5521C13.316 83.9201 12.5 81.9583 12.5 79.6667V21.3333C12.5 19.0417 13.316 17.0799 14.9479 15.4479C16.5799 13.816 18.5417 13 20.8333 13H79.1667C81.4583 13 83.4201 13.816 85.0521 15.4479C86.684 17.0799 87.5 19.0417 87.5 21.3333V79.6667C87.5 81.9583 86.684 83.9201 85.0521 85.5521C83.4201 87.184 81.4583 88 79.1667 88H20.8333ZM20.8333 79.6667H79.1667V21.3333H20.8333V79.6667ZM25 71.3333H75L59.375 50.5L46.875 67.1667L37.5 54.6667L25 71.3333ZM35.4167 42.1667C37.1528 42.1667 38.6285 41.559 39.8437 40.3437C41.059 39.1285 41.6667 37.6528 41.6667 35.9167C41.6667 34.1806 41.059 32.7049 39.8437 31.4896C38.6285 30.2743 37.1528 29.6667 35.4167 29.6667C33.6806 29.6667 32.2049 30.2743 30.9896 31.4896C29.7743 32.7049 29.1667 34.1806 29.1667 35.9167C29.1667 37.6528 29.7743 39.1285 30.9896 40.3437C32.2049 41.559 33.6806 42.1667 35.4167 42.1667Z",
    fill: "#3498D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImg);
export default __webpack_public_path__ + "static/media/default-img.8070e400a92007ae78dec068a50c5e79.svg";
export { ForwardRef as ReactComponent };